<role [state]="viewState.Edit"></role>
